import { HttpMethods } from "@/utils/constant";
import axiosServices from "@/service/axios/axios";
import axios from "axios";
import authAxiosServices from "@/service/axios/authAxios";
import hwmAxios from "@/service/axios/hwmAxios";
import { useLayoutStore } from "@/stores/layoutStore";
import { formatDateTime } from "@/utils/dateFormat";

const { VITE_ERP_API_BASE_URL } = import.meta.env;

export const postZguhadaWithdrawal = async () => {
  const url = `zguhada/withdrawal/`;
  const response = await axiosServices({
    method: HttpMethods.post,
    url: url,
    data: {
      withdrawal: true,
    },
  });

  return response.data;
};

// sns 연동 해제
export const getUnlinkSns = async ({ snsName }) => {
  const url = `zguhada/unlink/sns/`;

  try {
    const response = await axiosServices({
      method: HttpMethods.get,
      url: url,
      params: {
        sns: snsName,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLoginSns = async ({ snsType, code, redirectUrl }) => {
  const url = `zguhada/login/sns/`;
  try {
    return (
      await authAxiosServices({
        method: HttpMethods.get,
        url: url,
        params: {
          code: code,
          sns: snsType,
          redirect_uri: redirectUrl,
        },
      })
    ).data;
  } catch (error) {
    throw error;
  }
};

// sns 연동
export const getLinkSns = async ({ snsType, code, redirectUrl }) => {
  const url = `zguhada/link/sns/`;
  try {
    return (
      await axiosServices({
        method: HttpMethods.get,
        url: url,
        params: {
          code: code,
          sns: snsType,
          redirect_uri: redirectUrl,
        },
      })
    ).data;
  } catch (error) {
    throw error;
  }
};

// 프로필 정보 조회
export const postLoginToken = async () => {
  const url = `zguhada/login/`;

  try {
    const response = await axiosServices({
      method: HttpMethods.post,
      url: url,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBanner = async () => {
  const url = `zguhada/contents/`;

  try {
    const response = await axiosServices({
      method: HttpMethods.get,
      url: url,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

/* 철거 견적 문의 */
export const postQuoteInquiry = async (
  name,
  number,
  dueDate,
  address,
  detailAddress,
  area,
  etcInquiries,
  isAgreement,
) => {
  const url = `zguhada/inquiry/demolition/`;
  try {
    const response = await axiosServices({
      method: HttpMethods.post,
      url: url,
      data: {
        name: name,
        number: number,
        due_date: dueDate,
        address: address,
        detail_address: detailAddress,
        area: area,
        etc_inquiries: etcInquiries,
        is_agreement: isAgreement,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/* 폐기물 수거 문의 */
export const postCollectInquiry = async (
  name,
  number,
  dueDate,
  address,
  detailAddress,
  materialType,
  vehicleType,
  materialSize,
  etcInquiries,
  needForklift,
  registerOlbaro,
  siteImage,
  isAgreement,
) => {
  const url = `zguhada/inquiry/collection/`;
  try {
    const response = await axiosServices({
      method: HttpMethods.post,
      url: url,
      data: {
        name: name,
        number: number,
        due_date: dueDate,
        address: address,
        detail_address: detailAddress,
        material_type: materialType,
        vehicle_type: vehicleType,
        material_size: materialSize,
        etc_inquiries: etcInquiries,
        need_forklift: needForklift,
        register_olbaro: registerOlbaro,
        site_image: siteImage,
        is_agreement: isAgreement,
      },
    });
    return response.data;
  } catch (error) {
    return error.response;
  }
};

/* 폐기물 수거 문의 - 이미지 업로드 */

// protected file을 등록하기 위한 api들
const requestProtectedFilePrepare = async (filename) => {
  // protected file을 등록하기 위해 signed url을 요청한다
  let config = {
    method: HttpMethods.get,
    url: `common/file/protected/any/?filename=${filename}`,
  };
  const response = await axiosServices(config);
  return response.data;
};

const completeProtectedFile = async (prepare) => {
  // signed url에 업로드 성공 후 서버에 파일을 등록한다.
  let config = {
    method: HttpMethods.post,
    url: `common/file/protected/any/`,
    data: JSON.stringify(prepare),
    headers: { "Content-Type": "application/json" },
  };
  console.log("config: ", config);
  const response = await axiosServices(config);
  return response.data;
};

const uploadToS3 = async (prepare, fileObject) => {
  // S3에 파일을 업로드한다.
  const response = await axios.put(prepare.upload_url, fileObject, {
    headers: { "Content-Type": fileObject.type },
  });
  if (response.status !== 200) {
    throw new Error("Failed to upload to S3");
  }
  return prepare;
};

export const uploadProtectedFile = async (fileList) => {
  try {
    const prepareList = [];
    for (const file of fileList) {
      const prepare = await requestProtectedFilePrepare(file.file.name);
      await uploadToS3(prepare, file.file);
      prepareList.push(prepare);
    }
    return await completeProtectedFile(prepareList);
  } catch (error) {
    throw error;
  }
};

export const getUserServiceHistory = async ({ isCancel }) => {
  try {
    const url = `/zguhada/user/service/history/`;

    const response = await axiosServices({
      method: HttpMethods.get,
      url: url,
      params: {
        cancel_yn: isCancel ? "1" : "0",
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getImageUploadUrl = async (extension) => {
  const url = `/zguhada/blw/collectionRequest/image/upload/`;
  const response = await axiosServices({
    method: HttpMethods.get,
    url: url,
    params: {
      extension: extension,
    },
  });

  return response.data;
};

export const putImageUpload = async (url, formData) => {
  try {
    await axios
      .put(url, formData, {
        headers: {
          "Content-Type": "image",
        },
      })
      .then((res) => {
        console.log(`res.data ${res.data}`);
      });
  } catch (error) {
    console.error("업로드 실패:", error);
    throw error;
  }
};

export const postBlwDisposeReportRequest = async ({
  govId,
  name,
  cellphone,
  disposeMemo,
  disposeDate,
  address,
  detailAddress,
  addressType,
  postcodeJson,
  disposeLocationId,
  registeredLocationId,
  paymentMethod,
  paymentId,
  itemList,
  uploadImages,
  channel,
  cash_receipt_type,
  cash_receipt_number,
}) => {
  const url = `/zguhada/blw/${govId}/disposeReport/request/`;

  const convertAddressType = addressType === "ROAD_ADDR" ? "road" : "jibun";

  var convertPostCodeJson = postcodeJson;
  if (typeof postcodeJson == "string") {
    convertPostCodeJson = JSON.parse(postcodeJson);
  }

  const params = {
    name: name,
    cellphone: cellphone,
    address: address,
    detail_address: detailAddress,
    address_type: convertAddressType,
    postcode_json: convertPostCodeJson,
    dispose_location_id: disposeLocationId,
    registered_location_id: registeredLocationId,
    payment_method: paymentMethod,
    payment_id: paymentId,
    item_list: itemList,
    upload_images: uploadImages,
    channel: channel,
    dispose_memo: disposeMemo,
    dispose_date: disposeDate,
    cash_receipt_type: cash_receipt_type,
    cash_receipt_number: cash_receipt_number,
  };

  const response = await axiosServices({
    method: HttpMethods.post,
    url: url,
    data: params,
  });

  return response.data;
};

// 대생페 내려드림
export const postBlwDisposeCollectRequest = async ({
  dispose_date,
  address,
  detail_address,
  address_type,
  postcode_json,
  item_list,
  upload_images,
  is_elevator,
  floor,
}) => {
  const url = `/zguhada/blw/collectionRequest/request/`;

  var params = {
    dispose_date: dispose_date,
    address: address,
    detail_address: detail_address,
    address_type: address_type,
    postcode_json: postcode_json,
    item_list: item_list,
    upload_images: upload_images,
    is_elevator: is_elevator,
  };

  if (floor != null) {
    params["floor"] = floor;
  }

  try {
    const response = await axiosServices({
      method: HttpMethods.post,
      url: url,
      data: params,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

// 공생폐 버려드림
export const postCswCollectionRequest = async ({
  material,
  quantity,
  address,
  address_detail,
  address_type,
  postcode_json,
  phone_number,
  name,
  company_type,
  collection_request_date,
  expect_supply_fee,
}) => {
  const url = "/zguhada/csw/collectionRequest/request/";

  const params = {
    material: material,
    quantity: quantity,
    address: address,
    detail_address: address_detail,
    address_type: address_type,
    postcode_json: postcode_json,
    phone_number: phone_number,
    name: name,
    company_type: company_type,
    collection_request_date: collection_request_date,
    expect_supply_fee,
  };
  try {
    const response = await axiosServices({
      method: HttpMethods.post,
      url: url,
      data: params,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

// 공생폐 배출신고 중복 접수 확인
export const getCswDisposeReportDuplicateCheck = async ({
  phone_number,
  b_code,
  bonbun,
  bubun,
}) => {
  const url = "/zguhada/csw/disposeReport/duplicateCheck/";
  try {
    const response = await axiosServices({
      method: HttpMethods.get,
      url: url,
      params: {
        phone_number,
        b_code,
        bonbun,
        bubun,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

// 공생폐 업종 값 매핑: 프론트 CswCompanyType → HWM SiteHouseholdWasteCompanyTypeChoice
const HWM_COMPANY_TYPE_MAP = {
  collection_trans: "waste_collection",
  demolish: "demolition",
  storage: "warehouse",
};

// 공생폐 배출신고 (HWM 공개 API 직접 호출)
// dispose_method에 따라 마대(gunny_sack) / 직접운반(logistic) 상세 블록을 정확히 하나 싣는다.
export const postCswReportRequest = async ({
  material,
  address_id,
  address_detail,
  phone_number,
  name,
  company_type,
  dispose_date,
  dispose_method,
  sack_count,
  car_no,
  collection_site_id,
  declared_weight,
  photos,
  verification_id,
}) => {
  const url = "zguhada/v1/site-household-wastes/";
  const params = {
    verification_id: verification_id,
    applicant_name: name,
    applicant_phone: phone_number,
    address_id: address_id,
    detail_address: address_detail ?? "",
    dispose_date: dispose_date,
    material: material,
    company_type: HWM_COMPANY_TYPE_MAP[company_type] ?? company_type,
    dispose_method: dispose_method,
    photos: (photos ?? []).map((path) => ({ image: path })),
  };
  if (dispose_method === "gunny_sack") {
    params.gunny_sack = { sack_count: sack_count };
  } else {
    params.logistic = {
      vehicle_number: car_no,
      collection_site_id: collection_site_id,
      declared_weight: declared_weight,
    };
  }
  try {
    const response = await hwmAxios({
      method: HttpMethods.post,
      url: url,
      data: params,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

// 공생폐 배출신고 30일 중복 사전확인 (HWM 공개 API 직접 호출)
export const checkHwmCswDuplicate = async ({ addressId, phoneNumber }) => {
  const url = "zguhada/v1/site-household-wastes/check-duplicate/";
  try {
    const response = await hwmAxios({
      method: HttpMethods.post,
      url: url,
      data: {
        address_id: addressId,
        phone_number: phoneNumber,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

// 공생폐 배출신고 집하장 검색 (HWM 공개 API, b_code 소속 지자체의 활성 집하장만 반환)
export const getHwmWasteCollectionSites = async ({ bCode, q }) => {
  const url = "zguhada/v1/waste-collection-sites/";
  try {
    const response = await hwmAxios({
      method: HttpMethods.get,
      url: url,
      params: {
        b_code: bCode,
        ...(q ? { q } : {}),
      },
    });

    const data = response.data;
    return Array.isArray(data) ? data : data?.results ?? [];
  } catch (error) {
    throw error;
  }
};

// 공생폐 배출신고 사진 업로드 (HWM 공개 API) — 각 파일의 { name(경로), url(presigned) } 배열을 반환한다.
// name: 접수 API payload(photos)에 실을 저장 경로. url: make.com이 이미지를 fetch할 presigned GET URL(만료 3600초).
export const uploadHwmFiles = async (fileList) => {
  try {
    const files = [];
    for (const file of fileList) {
      const formData = new FormData();
      formData.append("file", file.file);
      const response = await hwmAxios({
        method: HttpMethods.post,
        url: "zguhada/v1/files/upload/",
        data: formData,
      });
      files.push({ name: response.data.path, url: response.data.url });
    }
    return files;
  } catch (error) {
    throw error;
  }
};

// 공생폐 배출신고 접수 데이터를 make.com 웹훅으로 전송(엑셀 누적).
// 부수효과성 best-effort 호출: 실패해도 접수 자체엔 영향 없으므로 호출부에서 무시 + Sentry 기록만 한다.
// hwmAxios/axiosServices의 인터셉터(로딩 오버레이·토큰·401 refresh)를 타지 않도록 raw axios를 직접 사용한다.
export const postCswToMakeWebhook = async (payload) => {
  const url = import.meta.env.VITE_CSW_MAKE_WEBHOOK_URL;
  if (!url) return; // URL 미설정(로컬 등)에선 조용히 스킵
  // 짧은 타임아웃으로 make.com 지연이 UI 흐름을 막지 않게 한다.
  await axios.post(url, payload, { timeout: 8000 });
};

/* response 예시
{
    "id": 1,
    "name": "성동구청",
    "payment_account_id": "f0614336-a0ae-4d40-9065-4b856bab060f",
    "pg_payment_method_id": "1f5c2484-be9c-4fc9-ab34-16d148ba5f9a",
    "payment_secret_key": "hIoedqHmTc6cToBCsosY7AFcAn0mpRa7SQpZj8tcaZU",
    "bank_account": {
        "id": 1,
        "name": "김원빈계좌",
        "bank": "031",
        "bank_display": "대구은행",
        "account_number": "508140843236",
        "account_holder": "김원빈"
    }
}
*/

export const getBlwServiceGovernment = async (
  guCode,
  addressName,
  addressType,
  x,
  y,
  address,
  roadAddress,
) => {
  const url = `/zguhada/blw/serviceGovernment/${guCode}`;

  const params = {
    address_name: addressName,
    addressType: addressType,
    x: x,
    y: y,
    address: address,
    road_address: roadAddress,
  };

  const response = await axiosServices({
    method: HttpMethods.get,
    url: url,
    params: params,
  });

  return response.data;
};

/*
{
    "registered_location_id": 3,
    "dispose_location_id": 1
}
*/
export const getBlwDisposeLocation = async ({
  govId,
  x,
  y,
  b_code,
  h_code,
  bonbun,
  bubun,
} = {}) => {
  const url = `/zguhada/blw/${govId}/disposeLocation/`;
  const response = await axiosServices({
    method: HttpMethods.get,
    url: url,
    params: {
      x: x,
      y: y,
      b_code: b_code,
      h_code: h_code,
      bonbun: bonbun,
      bubun: bubun,
    },
  });

  return response.data;
};

/*
"category_list": [
    {
      "id": 635,
      "name": "공기청정기",
      "parent_id": 318,
      "level": 3,
      "zguhada_icon": null
    },
    {
      "id": 315,
      "name": "TV/오디오",
      "parent_id": 312,
      "level": 2,
      "zguhada_icon": null
    },
    {
      "id": 720,
      "name": "아동용 자전거",
      "parent_id": 344,
      "level": 3,
      "zguhada_icon": null
    },
    {
      "id": 700,
      "name": "선반",
      "parent_id": 308,
      "level": 3,
      "zguhada_icon": null
    },
    {
      "id": 734,
      "name": "씨디장",
      "parent_id": 300,
      "level": 3,
      "zguhada_icon": null
    },
*/
export const getProductCategoryList = async (govId) => {
  try {
    const url = `/zguhada/blw/${govId}/product/category/list/`;

    const response = await axiosServices({
      method: HttpMethods.get,
      url: url,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

/*
{
    "category_list": [
        {
            "id": 303,
            "name": "의자",
            "parent_id": 297,
            "level": 2,
            "zguhada_icon": null,
            "order_value": 9999
        },
        {
            "id": 730,
            "name": "스툴/화장대 의자(미니)",
            "parent_id": 303,
            "level": 3,
            "zguhada_icon": null,
            "order_value": 9999
        },
        {
            "id": 736,
            "name": "안마의자",
            "parent_id": 319,
            "level": 3,
            "zguhada_icon": null,
            "order_value": 9999
        },
        {
            "id": 753,
            "name": "범보의자",
            "parent_id": 344,
            "level": 3,
            "zguhada_icon": null,
            "order_value": 9999
        },
        {
            "id": 784,
            "name": "바퀴 달린 의자",
            "parent_id": 303,
            "level": 3,
            "zguhada_icon": null,
            "order_value": 9999
        },
        {
            "id": 785,
            "name": "의자",
            "parent_id": 303,
            "level": 3,
            "zguhada_icon": null,
            "order_value": 9999
        },
        {
            "id": 799,
            "name": "의자(플라스틱)",
            "parent_id": 303,
            "level": 3,
            "zguhada_icon": null,
            "order_value": 9999
        },
        {
            "id": 810,
            "name": "차량용 의자(앞좌석)",
            "parent_id": 346,
            "level": 3,
            "zguhada_icon": null,
            "order_value": 9999
        },
        {
            "id": 813,
            "name": "캠핑/낚시 의자",
            "parent_id": 340,
            "level": 3,
            "zguhada_icon": null,
            "order_value": 9999
        }
    ]
}
*/
export const getProductCategoryListSearch = async (govId, name) => {
  const url = `/zguhada/blw/${govId}/product/category/list/`;

  let params = {};

  if (name !== "" || name !== null) {
    params = {
      name: name,
    };
  }

  const response = await axiosServices({
    method: HttpMethods.get,
    url: url,
    params: params,
  });

  return response.data;
};

/*
{
    "id": 786,
    "name": "모든 규격",
    "price": 7000
}
*/

export const getProductStandardList = async (govId, categoryId) => {
  const url = `/zguhada/blw/${govId}/product/standard/list/`;

  const response = await axiosServices({
    method: HttpMethods.get,
    url: url,
    params: {
      product_id: categoryId,
    },
  });

  return response.data;
};

/* response 예시
{
    "payment_account_id": "f0614336-a0ae-4d40-9065-4b856bab060f",
    "payment_method_id": "1f5c2484-be9c-4fc9-ab34-16d148ba5f9a",
    "payment_id": "53a5222a-519f-428d-9dfc-d943c5783ff4",
    "payment_type": "cert",
    "next_url": "https://backend-dev.soogobot.com/payment/1f5c2484-be9c-4fc9-ab34-16d148ba5f9a/53a5222a-519f-428d-9dfc-d943c5783ff4/cert/",
    "cert_callback_url": "https://backend-dev.soogobot.com/payment/1f5c2484-be9c-4fc9-ab34-16d148ba5f9a/53a5222a-519f-428d-9dfc-d943c5783ff4/cert/callback/",
    "finish_url": "https://backend.soogobot.com/?uid=53a5222a-519f-428d-9dfc-d943c5783ff4",
    "buyer_name": null,
    "buyer_tel": null,
    "buyer_email": null,
    "request_data": {
        "GoodsName": "대형 생활 폐기물 배출 품목",
        "Amt": 2000,
        "TaxFreeAmt": 0,
        "MID": "nicepay00m",
        "EdiDate": "202401091412",
        "Moid": "53a5222a-519f-428d-9dfc-d943c5783ff4",
        "SignData": "afb34610fea141d03f822bc44f928d199dbfecca6ae4ab782f2623f9679ed127",
        "BuyerName": null,
        "BuyerTel": null,
        "PayMethod": "CARD",
        "BuyerEmail": null,
        "CharSet": "utf-8"
    },
    "cert_response_data": null,
    "approve_response_data": null,
    "status": "pc"
}

*/

export const postPaymentRequest = async (
  payment_method_id,
  amount,
  buyerName,
  buyerTel,
  isMobile,
  { paymentId, paymentSecretKey },
) => {
  const url = `/payment/${payment_method_id}/request/`;

  const response = await axiosServices({
    method: HttpMethods.post,
    url: url,
    headers: {
      "X-Chunil-Payment-Id": paymentId,
      "X-Chunil-Payment-Secret": paymentSecretKey,
    },
    data: {
      amount: amount,
      app: "zguhada",
      item_title: "대형 생활 폐기물 배출 품목",
      is_mobile: isMobile,
      tax_free: amount, // 대폐 비과세라 amount 같게.
      buyer_name: buyerName,
      buyer_tel: buyerTel,
      // finish_url: "https://backend.soogobot.com/",
    },
  });

  return response.data;
};

// 2025/06/30 추가된 api
// https://backend-dev.soogobot.com/api/zguhada/blw/{ser_gov_id}/disposeReport/request/{request_id}/payment/
export const postDisposeReportPayment = async ({
  serGovId,
  requestId,
  isMobile,
  host = null,
  wbErrorScheme = null,
  wbSuccessScheme = null,
} = {}) => {
  try {
    const url = `/zguhada/blw/${serGovId}/disposeReport/request/${requestId}/payment/`;

    const response = await axiosServices({
      method: HttpMethods.post,
      url: url,
      data: {
        is_mobile: isMobile,
        host: host,
        wb_error_scheme: wbErrorScheme,
        wb_success_scheme: wbSuccessScheme,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDisposeReportRequestDetail = async ({
  serGovId,
  requestId,
} = {}) => {
  try {
    const url = `/zguhada/blw/${serGovId}/disposeReport/request/${requestId}/detail/`;

    const response = await axiosServices({
      method: HttpMethods.get,
      url: url,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

// 배출신고 취소 api
// refundBankId, refundAccountNumber, refundAccountHolder payment_method 가 "MB", 계좌이체 일때
export const postUserServiceCancel = async (
  id,
  serviceType,
  { refundBankId, refundAccountNumber, refundAccountHolder } = {},
) => {
  const url = `/zguhada/user/service/cancel/`;

  let data = {
    id: id,
    service_type: serviceType,
  };

  if (refundBankId != null) {
    data = {
      blw_dispose_report_refund_bank: refundBankId,
      blw_dispose_report_refund_account_number: refundAccountNumber,
      blw_dispose_report_refund_account_holder: refundAccountHolder,
      ...data,
    };
  }

  const response = await axiosServices({
    method: HttpMethods.post,
    url: url,
    data: data,
  });

  return response.data;
};

export const getWasteMapList = async () => {
  const layoutStore = useLayoutStore();
  try {
    layoutStore.showOverlay();
    const url = `${VITE_ERP_API_BASE_URL}wastemap/v1/list/`;
    const response = await axios({
      method: HttpMethods.get,
      url: url,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    });

    console.log("############################");
    console.log(`request api ${url}`);
    console.log(response.data);
    console.log("############################");

    layoutStore.hideOverlay();
    return response.data;
  } catch (error) {
    layoutStore.hideOverlay();
    console.log("############################");
    console.log(error);
    console.log("############################");

    throw error;
  }
};

export const getWasteMapListSearch = async (search) => {
  const layoutStore = useLayoutStore();
  try {
    layoutStore.showOverlay();
    const url = `${VITE_ERP_API_BASE_URL}wastemap/v1/list/`;
    const response = await axios({
      method: HttpMethods.get,
      url: url,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    });

    console.log("############################");
    console.log(`request api ${url} search`);

    const result = response.data.filter((element) => {
      if (element.name) {
        return element.name.includes(search);
      }

      return false;
    });
    console.log(result);

    console.log("############################");

    layoutStore.hideOverlay();
    return result;
  } catch (error) {
    layoutStore.hideOverlay();
    console.log("############################");
    console.log(error);
    console.log("############################");

    throw error;
  }
};

/*
- Path params
  - `사업장_id` : 리스트에서 반환한 사업장의 `id` 값
- Query params
  - `max_date`(optional): 조회 종료일. `yyyy-mm-dd` 형태로 전달. 기본값은 현재일. 이 날짜를 포함한 이전의 데이터만 조회한다.
  - `min_date`(optional): 조회 시작일. `yyyy-mm-dd` 형태로 전달. 기본값은 조회 종료일-30일. 이 날짜를 포함한 이후의 데이터만 조회한다.
*/
export const getWasteMapPriceDetail = async (id) => {
  const layoutStore = useLayoutStore();
  try {
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 6);

    const url = `${VITE_ERP_API_BASE_URL}wastemap/v1/${id}/price/`;
    layoutStore.showOverlay();
    const response = await axios({
      method: HttpMethods.get,
      url: url,
      params: {
        min_date: formatDateTime(minDate, "YYYY-MM-DD"),
      },
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    });

    console.log("############################");
    console.log(`request api ${url}`);
    console.log(response.data);
    console.log("############################");

    layoutStore.hideOverlay();
    return response.data;
  } catch (error) {
    layoutStore.hideOverlay();

    console.log("############################");
    console.log(error);
    console.log("############################");

    throw error;
  }
};

export const getAddress = async (inputVal, page) => {
  try {
    const url = `common/postcode/chunil/search/`;
    const response = await axiosServices({
      method: HttpMethods.get,
      url: url,
      params: {
        query: inputVal,
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 공생폐 배출신고 전용 HWM 주소검색 (HWM 공개 API 직접 호출)
export const getHwmAddress = async (inputVal, page) => {
  try {
    const url = `zguhada/v1/address/search/`;
    const response = await hwmAxios({
      method: HttpMethods.get,
      url: url,
      params: {
        query: inputVal,
        page: page,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 선택한 HWM 주소검색 결과 1건을 확정해 HWM Address id 를 받는다
export const selectHwmAddress = async (result) => {
  try {
    const url = `zguhada/v1/address/select/`;
    const response = await hwmAxios({
      method: HttpMethods.post,
      url: url,
      data: result,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
